import { render, staticRenderFns } from "./IntroImage.vue?vue&type=template&id=8bb2281a&scoped=true&"
import script from "./IntroImage.vue?vue&type=script&lang=js&"
export * from "./IntroImage.vue?vue&type=script&lang=js&"
import style0 from "./IntroImage.vue?vue&type=style&index=0&id=8bb2281a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb2281a",
  null
  
)

export default component.exports